import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { NGXLogger } from "ngx-logger";
import { Workspace } from "../state/workspaces.model";
import { Store } from "@ngrx/store";
import { CreateWorkspace } from "../state/workspaces.actions";

@Component({
  selector: "app-workspace-editor",
  templateUrl: "./workspace-editor.component.html",
  styleUrls: ["./workspace-editor.component.scss"],
  standalone: false,
})
export class WorkspaceEditorComponent implements OnInit {
  form: UntypedFormGroup;

  LABEL = "label";

  constructor(
    private dialogRef: MatDialogRef<WorkspaceEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public workspace: Workspace,
    private logger: NGXLogger,
    private store: Store<any>,
  ) {}

  ngOnInit(): void {
    // Initial form values
    let label = "";

    if (this.workspace) {
      label = this.workspace.label;
    }

    this.logger.debug(`Initialize workspace form`);
    this.form = new UntypedFormGroup({
      [this.LABEL]: new UntypedFormControl(label, [Validators.required]),
    });
  }

  done() {
    if (this.workspace) {
      // Editing and existing workspace
      // TODO
    } else {
      // Creating a new workspace
      const workspace: Workspace = {
        uuid: null,
        name: null,
        label: this.form.get(this.LABEL).value,
        owner: null,
      };
      this.store.dispatch(new CreateWorkspace(workspace));
    }
    this.dialogRef.close();
  }

  cancel() {
    this.dialogRef.close();
  }
}
